// removed by extract-text-webpack-plugin
module.exports = {"App":"App__App___1o-Fp","AppBlueBackground":"App__AppBlueBackground___3MQZW","AppLogo":"App__AppLogo___3CmcG","App-logo-spin":"App__App-logo-spin___RvI1J","AppHeader":"App__AppHeader___1k1Hg","ResultHeader":"App__ResultHeader___3qhHW","AppIntro":"App__AppIntro___eEOyl"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 230
// module chunks = 0